export enum DiscountVisitType {
    Credit = 1,
    Cash = 2,
    Both = 3,
}
